import { GetTextWithVersionBadge } from "../../../../Common/Badge/Badge";
import { TableDataRowProps } from "../../../../Common/UI/Index";
import { ExportStatus } from "../../../Versioning/GetVersions/Constant";
import { IScheduleListType } from "../../CreateSchedule/redux/Types";
import { convertDateToView, getFormattedDate } from "../../Helper/Script";
import { getStatus, getValidity } from "./Scripts";

/**
 Method for making first letter capitalize for recurrence type
 */
export const capitalizeFirstLetter = (data: string): string => {
  return data.charAt(0).toUpperCase() + data.slice(1);
};

/**
 Method for populating the schedule table
 */

export const populateTableData = (scheduleList: IScheduleListType[]): TableDataRowProps[] => {

  return scheduleList.map((item: IScheduleListType) => {
    const rangeEnd = item.recurrenceData.recurrenceNoOfOccurrences ?
      `After ${item.recurrenceData.recurrenceNoOfOccurrences} occurrences`
      : getFormattedDate(convertDateToView(item.recurrenceData.recurrenceRangeEnd || ""), true);
    const scheduleTableRow: TableDataRowProps = {
      row: [
        {
          value: GetTextWithVersionBadge(ExportStatus?.DRAFT, item.scheduleName),
          propertyName: "scheduleName",
          id: "scheduleName"
        },
        {
          value: getStatus(item.isActive),
          propertyName: "activeInLive",
          id: "activeInLive"
        },
        {
          value: capitalizeFirstLetter(item.recurrenceType) ,
          propertyName: "recurrenceType",
          id: "recurrenceType"
        },
        {
          value: getFormattedDate(convertDateToView(item.recurrenceData.recurrenceRangeStart || ""), true),
          propertyName: "recurrenceRangeStart",
          id: "recurrenceRangeStart"
        },
        {
          value: rangeEnd,
          propertyName: "recurrenceRangeEnd",
          id: "recurrenceRangeEnd"
        },
        {
          value: getValidity(item.isValid),
          propertyName: "validity",
          id: "validity"
        }
      ]
    };
    return scheduleTableRow;
  });
};
